<template>
  <b-modal
    id="page-package-card-modal"
    :ok-title="trans(block && block.id ? 'save' : 'create')"
    :ok-disabled="!package_id"
    :cancel-title="trans('cancel')"
    size="lg"
    no-enforce-focus
    @shown="onShown"
    @hidden="shown = false"
    @ok="onSave"
  >
    <template v-slot:modal-title>
      <span>{{ trans('package') }}</span>
      <small v-if="!!block" class="text-muted ml-2">
        #{{ block.id }}
      </small>
    </template>

    <b-row>
      <b-col :class="tab != 1 ? 'col-12 col-lg-8' : 'col-12'">
        <b-tabs v-model="tab" content-class="mt-3">
          <b-tab :title="trans('form')">
            <b-form-group>
              <package-dropdown
                v-if="shown"
                :organization="organization"
                v-model="package_id"
                @package="onSelectPackage"
                :disabled="busy"
              ></package-dropdown>
            </b-form-group>

            <b-form-group :label="trans('button')">
              <b-form-input
                v-model="button_text"
                :disabled="busy"
              />
            </b-form-group>

            <b-form-group :label="trans('anchor_target')">
              <b-form-select
                v-model="button_target"
                :options="button_target_options"
                :disabled="busy"
              ></b-form-select>
            </b-form-group>

            <b-form-group :label="trans('width')">
              <b-form-radio-group v-model="image_percent" :options="image_percent_options" />
            </b-form-group>
            
            <b-form-group :label="trans('position')">
              <b-form-radio-group v-model="span_row">
                <b-form-radio :value="false">
                  {{ trans('inline') }}
                </b-form-radio>
                <b-form-radio :value="true">
                  {{ trans('span_row') }}
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group v-if="span_row" :label="trans('align')">
              <b-form-radio-group v-model="h_align" :options="hAlignOptions"></b-form-radio-group>
            </b-form-group>
          </b-tab>

          <b-tab :title="trans('text')">
            <b-form-group>
              <html-textarea
                :organization="organization"
                v-model="text"
                for-microsite
                show-insert-form-document
                :placeholders="placeholders"
              ></html-textarea>
            </b-form-group>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col v-if="tab != 1" class="col-6 col-lg-4">
        <page-card-block
          :block="serializedForPreview"
        ></page-card-block>
      </b-col>
    </b-row>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import PackageDropdown from './../package/PackageDropdown'
  import HtmlTextarea from './../../../common/components/HtmlTextarea'
  import PageCardBlock from './PageCardBlock'

  const defaultText = `
  <h5 style="text-align:center;">
    <span class="placeholder">{${lang == 'fr' ? 'Nom' : 'Name'}}</span>
  </h5>
  <p>
    <span class="placeholder">{${lang == 'fr' ? 'Courte description' : 'Short description'}}</span>
  </p>`

  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
      after: Number,
    },
    components: {
      PackageDropdown,
      HtmlTextarea,
      PageCardBlock,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        shown: false,
        tab: 0,
        text: defaultText,
        button_text: trans('book_now'),
        button_url: null,
        button_target: null,
        button_target_options: [
          {text: trans('anchor_target_self'), value: null}, // self
          {text: trans('anchor_target_blank'), value: '_blank'},
        ],
        image_percent: 0.3333,
        image_percent_options: [
          {text: '25%', value: 0.25},
          {text: '33%', value: 0.3333},
          {text: '50%', value: 0.5},
          {text: '66%', value: 0.6666},
          {text: '75%', value: 0.75},
          {text: '100%', value: 1.0},
        ],
        span_row: false,
        h_align: 'center',
        hAlignOptions: [
          {value: 'left', text: trans('left')},
          {value: 'center', text: trans('center')},
          {value: 'right', text: trans('right')},
        ],
        package_id: null,
        pkg: null,
      }
    },
    computed: {
      serialized() {
        return {
          type: 'package-card',
          text: this.text,
          button_text: this.button_text,
          button_url: this.button_url,
          button_target: this.button_target,
          package_id: this.package_id,
          image_url: this.pkg ? this.pkg.image_url : null,
          image_percent: this.image_percent,
          span_row: this.span_row,
          h_align: this.h_align,
          meta: this.meta,
          after: this.after,
          // This is only for rendering the block in design mode
          package_name: this.pkg ? this.pkg.name : null,
          package_short_description: this.pkg ? this.pkg.short_description : null,
          package_image_url: this.pkg ? this.pkg.image_url : null,
        }
      },
      serializedForPreview() {
        return _.assign({}, this.serialized, {span_row: false})
      },
      placeholders() {
        return window.lang == 'fr' ?
          ['Nom', 'Courte description'] :
          ['Name', 'Short description']
      },
    },
    methods: {
      onSelectPackage(pkg, context) {
        this.pkg = pkg
        this.button_url = pkg ? pkg.page_url : null
        if (context && context.source == 'user') {
          this.text = defaultText
        }
      },
      onShown() {
        this.busy = false
        this.error = null
        this.pkg = null
        this.text = this.block ? this.block.text : defaultText
        this.button_text = this.block ? this.block.button_text : trans('book_now')
        this.button_url = this.block ? this.button_url : null
        this.button_target = this.block ? this.block.button_target : null
        this.package_id = this.block ? this.block.package_id : null
        this.image_percent = this.block ? this.block.image_percent : 0.3333
        this.span_row = this.block ? this.block.span_row || false : false
        this.h_align = this.block ? this.block.h_align || 'center' : 'center'
        this.shown = true
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/page/${this.page.id}/block`
        if (this.block && this.block.id) url += `/${this.block.id}`
        axios[this.block && this.block.id ? 'patch' : 'post'](url, this.serialized)
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide('page-package-card-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.pagePackageCardModal = this
    },
  }
</script>